import script from "./ElectronicInvoice.vue?vue&type=script&setup=true&lang=ts"
export * from "./ElectronicInvoice.vue?vue&type=script&setup=true&lang=ts"

import "./ElectronicInvoice.vue?vue&type=style&index=0&id=5457fc2e&lang=scss&scoped=true"

import exportComponent from "/data/.jenkins/workspace/Shita-erp-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5457fc2e"]])

export default __exports__